import "./node_modules/bootstrap/dist/css/bootstrap.css";
import "./src/styles/global.css";